import React from 'react';
import { CountryCode, CountryFlagForCode, CountryName, CountryNameKey } from '@dayetopia/types';
import styled from 'styled-components';
import LinkTranslated from '@components/shared/LinkTranslated';
import { getCurrencyFromCountryCode } from '@utils/currency';
import { getLocaleByCountryCode, removeLocalesFromPath } from '@utils/language';
import useCurrentLocation from '@utils/useCurrentLocation';

const SEOHiddenLocalisedUrls = () => {
  const currentLocation = useCurrentLocation();

  return (
    <Wrapper>
      {Object.entries(CountryFlagForCode)
        .filter(([countryCode]) => CountryName[countryCode as CountryNameKey])
        .map(([countryCode]) => {
          return (
            <LinkTranslated
              key={countryCode}
              to={removeLocalesFromPath(currentLocation)}
              language={getLocaleByCountryCode(countryCode as CountryCode)}
            >
              {CountryName[countryCode as CountryNameKey]} ({getCurrencyFromCountryCode(countryCode as CountryCode)})
            </LinkTranslated>
          );
        })}
    </Wrapper>
  );
};

export default SEOHiddenLocalisedUrls;

const Wrapper = styled.div`
  display: none;
`;
